import { getDataRequest, postDataRequest } from "../helper/AxiosHelper";

// ----------------------------------------------------------------------
// #region School Leaderboard

const getSchoolLeaderboardCallback = (orgID, mode, filters, callback) => {
  // {{host}}/api/organization/getOrgMissionSetting/1
  let url = `/admin/schoolLeaderboard/${orgID}`;

  // Add the query parameters
  const queryParams = new URLSearchParams();
  queryParams.append("mode", mode);
  queryParams.append("filters", JSON.stringify(filters));

  url += `?${queryParams.toString()}`;


  getDataRequest(url, (isSuccess, _data) => {
    if (!isSuccess) {
      let msg = _data;
      callback(false, msg, null); // _data is error message
      return;
    }

    callback(true, "", _data);
  });
};

// #endregion

// ----------------------------------------------------------------------
// #region Org Monthly Stats

const getOrgDashboardDataCallback = (orgID, year, startMonth, callback) => {
  // {{host}}/api/organization/getOrgMissionSetting/1
  let url = `/admin/orgStat/getDashboardData`;

  // Add the query parameters
  const queryParams = new URLSearchParams();
  queryParams.append("org_id", orgID);
  queryParams.append("year", year);
  queryParams.append("start_month", startMonth);

  url += `?${queryParams.toString()}`;
  const axiosOptions = {
    suppressAlert: true, // Custom option to suppress alert
  }
  getDataRequest(url, (isSuccess, _data) => {
    if (!isSuccess) {
      let msg = _data;
      callback(false, msg, null); // _data is error message
      return;
    }

    callback(true, "", _data);
  }, axiosOptions);
};

const getMonthlyParticipantDataCallback = (orgID, year, startMonth, callback) => {
  // {{host}}/api/organization/getOrgMissionSetting/1
  let url = `/admin/orgStat/getMonthlyParticipantData`;

  // Add the query parameters
  const queryParams = new URLSearchParams();
  queryParams.append("org_id", orgID);
  queryParams.append("year", year);
  queryParams.append("start_month", startMonth);

  url += `?${queryParams.toString()}`;
  const axiosOptions = {
    suppressAlert: true, // Custom option to suppress alert
  }
  getDataRequest(url, (isSuccess, _data) => {
    if (!isSuccess) {
      let msg = _data;
      callback(false, msg, null); // _data is error message
      return;
    }

    callback(true, "", _data);
  }, axiosOptions);
};

const getSkillParticipantDataCallback = (orgID, year, startMonth, callback) => {
  // {{host}}/api/organization/getOrgMissionSetting/1
  let url = `/admin/orgStat/getSkillParticipantData`;

  // Add the query parameters
  const queryParams = new URLSearchParams();
  queryParams.append("org_id", orgID);
  queryParams.append("year", year);
  queryParams.append("start_month", startMonth);

  url += `?${queryParams.toString()}`;
  const axiosOptions = {
    suppressAlert: true, // Custom option to suppress alert
  }
  getDataRequest(url, (isSuccess, _data) => {
    if (!isSuccess) {
      let msg = _data;
      callback(false, msg, null); // _data is error message
      return;
    }

    callback(true, "", _data);
  }, axiosOptions);
};


// #endregion


// #region Org Admin Leaderboard Setting 

const getMyLeaderboardSettingListCallback = (callback) => {
  let url = `/orgAdmin/myLeaderboardSettingList`;
  getDataRequest(url, (isSuccess, _data) => {
    if (!isSuccess) {
      let msg = _data;
      callback(false, msg, null); // _data is error message
      return;
    }

    callback(true, "", _data);
  });
};

const getLeaderboardSettingCallback = (id, callback) => {
  const url = `/orgAdmin/leaderboardSetting/${id}`;
  getDataRequest(url, (isSuccess, _data) => {
    if (!isSuccess) {
      callback(false, _data, null);
      return;
    }

    callback(true, "", _data);
  });
};

const getLeaderboardPreviewCallback = (code, callback) => {
  const url = `/orgAdmin/leaderboardPreview?code=${encodeURIComponent(code || "")}`;
  getDataRequest(url, (isSuccess, _data) => {
    if (!isSuccess) {
      callback(false, _data, null);
      return;
    }

    callback(true, "", _data);
  });
};

const createLeaderboardSettingCallback = async (formData, callback) => {
  await postDataRequest(
    "/orgAdmin/leaderboardSetting/create",
    formData,
    (isSuccess, message, responseData) => {
      if (!isSuccess) {
        callback(false, message, null);
        return;
      }

      const record = responseData?.result;
      if (record === null || record === undefined) {
        callback(false, "No record return", null);
        return;
      }

      callback(true, "", record);
    }
  );
};

const updateLeaderboardSettingCallback = async (id, formData, callback) => {
  await postDataRequest(
    `/orgAdmin/leaderboardSetting/update/${id}`,
    formData,
    (isSuccess, message, responseData) => {
      if (!isSuccess) {
        callback(false, message, null);
        return;
      }

      const record = responseData?.result;
      if (record === null || record === undefined) {
        callback(false, "No record return", null);
        return;
      }

      callback(true, "", record);
    }
  );
};

const getMyGrpListCallback = (callback) => {
  getDataRequest("/orgAdmin/grp", (isSuccess, _data) => {
    if (!isSuccess) {
      callback(false, _data, null);
      return;
    }

    callback(true, "", _data);
  });
};

const getGrpCallback = (id, callback) => {
  getDataRequest(`/orgAdmin/grp/${id}`, (isSuccess, _data) => {
    if (!isSuccess) {
      callback(false, _data, null);
      return;
    }

    callback(true, "", _data);
  });
};

const createGrpCallback = async (formData, callback) => {
  await postDataRequest(
    "/orgAdmin/grp/create",
    formData,
    (isSuccess, message, responseData) => {
      if (!isSuccess) {
        callback(false, message, null);
        return;
      }

      const record = responseData?.result;
      if (record === null || record === undefined) {
        callback(false, "No record return", null);
        return;
      }

      callback(true, "", record);
    }
  );
};

const updateGrpCallback = async (id, formData, callback) => {
  await postDataRequest(
    `/orgAdmin/grp/update/${id}`,
    formData,
    (isSuccess, message, responseData) => {
      if (!isSuccess) {
        callback(false, message, null);
        return;
      }

      const record = responseData?.result;
      if (record === null || record === undefined) {
        callback(false, "No record return", null);
        return;
      }

      callback(true, "", record);
    }
  );
};

const deleteGrpCallback = async (id, callback) => {
  await postDataRequest(
    `/orgAdmin/grp/delete/${id}`,
    {},
    (isSuccess, message, responseData) => {
      if (!isSuccess) {
        callback(false, message, null);
        return;
      }

      callback(true, "", responseData?.result ?? null);
    }
  );
};

const deleteLeaderboardSettingCallback = async (id, callback) => {
  await postDataRequest(
    `/orgAdmin/leaderboardSetting/delete/${id}`,
    {},
    (isSuccess, message, responseData) => {
      if (!isSuccess) {
        callback(false, message, null);
        return;
      }

      callback(true, "", responseData?.result ?? null);
    }
  );
};

// #endregion

// ----------------------------------------------------------------------

export const OrgAdminApi = {
  getMyGrpListCallback,
  getGrpCallback,
  createGrpCallback,
  updateGrpCallback,
  deleteGrpCallback,
  getMyLeaderboardSettingListCallback,
  getLeaderboardSettingCallback,
  getLeaderboardPreviewCallback,
  createLeaderboardSettingCallback,
  updateLeaderboardSettingCallback,
  deleteLeaderboardSettingCallback,
  getSkillParticipantDataCallback,
  getMonthlyParticipantDataCallback,
  getOrgDashboardDataCallback,
  getSchoolLeaderboardCallback,
};
